import type { ProductGroup } from '~/common/model/capabilities'

export type Product = {
  label: string
  value: string
  group: ProductGroup
  isReturnProduct: boolean
  // CCC return products optionally have a locationId, returnHubId and additionalCustomerInformation:
  locationId?: string
  returnHubId?: string
  additionalCustomerInformation?: string
}

export const isProductConfigurable = (product: Product): boolean =>
  product.isReturnProduct || product.value === 'DPI-CCC'
